import type { ReactNode } from 'react'
import { pillVariants } from './Pill.css'

type PillVariant = keyof typeof pillVariants

type Props = {
  variant: PillVariant
  children: ReactNode
}

export const Pill = ({ variant, children }: Props) => (
  <span className={pillVariants[variant]}>{children}</span>
)
